// 성능 최적화를 위한 로깅 설정
export interface PerformanceConfig {
  enableDebugLogs: boolean;
  enablePerformanceLogs: boolean;
  enableDataOperationLogs: boolean;
  enableUserActionLogs: boolean;
  enableBusinessEventLogs: boolean;
  maxLogFrequency: number; // ms 단위
  enableStackTrace: boolean;
}

// 환경별 설정
const developmentConfig: PerformanceConfig = {
  enableDebugLogs: true,
  enablePerformanceLogs: true,
  enableDataOperationLogs: true,
  enableUserActionLogs: true,
  enableBusinessEventLogs: true,
  maxLogFrequency: 100, // 100ms 간격으로 제한
  enableStackTrace: false // 스택 트레이스는 비활성화 (성능상 이유)
};

const productionConfig: PerformanceConfig = {
  enableDebugLogs: false,
  enablePerformanceLogs: false,
  enableDataOperationLogs: false,
  enableUserActionLogs: true,
  enableBusinessEventLogs: true,
  maxLogFrequency: 1000, // 1초 간격으로 제한
  enableStackTrace: false
};

// 현재 환경에 맞는 설정 선택
export const getPerformanceConfig = (): PerformanceConfig => {
  if (process.env.NODE_ENV === 'production') {
    return productionConfig;
  }
  
  // 개발 모드에서도 성능을 고려한 설정
  const isDevelopmentOptimized = process.env.REACT_APP_LOG_OPTIMIZED === 'true';
  
  if (isDevelopmentOptimized) {
    return {
      ...developmentConfig,
      enableDebugLogs: false, // 개발 모드에서도 디버그 로그 비활성화
      maxLogFrequency: 200
    };
  }
  
  return developmentConfig;
};

// 로그 주파수 제한을 위한 캐시
const logTimestamps = new Map<string, number>();

export const shouldLog = (category: string, config: PerformanceConfig): boolean => {
  const now = Date.now();
  const lastLog = logTimestamps.get(category) || 0;
  
  if (now - lastLog < config.maxLogFrequency) {
    return false; // 너무 자주 로깅하면 건너뛰기
  }
  
  logTimestamps.set(category, now);
  return true;
};

// 메모리 누수 방지를 위한 정리 함수
export const cleanupLogCache = (): void => {
  const now = Date.now();
  for (const [key, timestamp] of logTimestamps.entries()) {
    if (now - timestamp > 60000) { // 1분 이상 된 항목 제거
      logTimestamps.delete(key);
    }
  }
};

// 주기적으로 캐시 정리 (5분마다)
if (typeof window !== 'undefined') {
  setInterval(cleanupLogCache, 300000);
}